import { oauthTokenSelector } from 'selectors/app'
import { REACTIVATE_SUBSCRIPTION_REQUEST } from 'ducks/integrations/recharge/types'
import { doSdkRequest } from 'ducks/requests'
import { doLinkResource } from 'actions/userIntegrations'
import { getRechargeMerchantUrl } from 'ducks/integrations/recharge/utils'

import selectIntegrationForId from 'ducks/integrations/selectors/selectIntegrationForId'
import * as api from '../api'

const doReactivateSubscription = ({
  customerId,
  subscriptionId,
  integrationId,
}) => {
  return doSdkRequest(
    REACTIVATE_SUBSCRIPTION_REQUEST,
    async ({ getState, dispatch }) => {
      let state = getState()
      const token = oauthTokenSelector(state)

      const { response } = await api.reactivateSubscription(
        token,
        integrationId,
        subscriptionId
      )

      state = getState()

      const integration = selectIntegrationForId(state, integrationId)

      const subscriptionUrl = getRechargeMerchantUrl(
        integration.fullStoreDomain,
        `merchant/subscriptions/${subscriptionId}/details`
      )

      await dispatch(
        doLinkResource({
          id: `${customerId}-${subscriptionId}-subscription-reactivate`,
          provider: 'recharge',
          title: `${subscriptionId}-subscription-reactivate`,
          url: subscriptionUrl,
        })
      )

      return response
    },
    {
      customerId,
      subscriptionId,
      integrationId,
    },
    {
      moduleOptions: {
        toasts: {
          enabled: true,
          started: {
            enabled: false,
          },
          success: {
            enabled: true,
            content: 'Subscription reactivated successfully!',
          },
          failed: {
            content: 'Something went wrong.',
          },
        },
      },
    }
  )
}

export default doReactivateSubscription
